import React from "react";
import FormItem from "@components/FormItem/FormItem";
import FormSection from "@components/FormSection/FormSection";
import type { FormContext } from "@features/port-security/components/SecurityClearence.types.ts";
import type { PortSecurityFormData } from "@features/port-security/schema/portSecurityFormSchema";
import { t } from "i18next";
import { FormProvider } from "react-hook-form";
import { useOutletContext } from "react-router-dom";

const Signature: React.FC = () => {
  const { formData, updateFormData } = useOutletContext<FormContext>();
  const signatureData = formData.getValues("signatureAgreement");

  return (
    <FormProvider {...formData}>
      <FormSection title={t("security-clearance.agreement")}>
        <div className="md:col-span-2">
          <FormItem<PortSecurityFormData, "signatureAgreement">
            name="signatureAgreement"
            type="checkbox"
            label={t("security-clearance.signature-data-accuracy-confirmation")}
            testId="security-signatureAgreement"
            required
            onFieldChange={updateFormData}
            defaultValue={signatureData}
          />
        </div>
        <FormItem<PortSecurityFormData, "signatureName">
          name="signatureName"
          type="text"
          maxChars={200}
          label={t("security-clearance.signature-name")}
          testId="security-signatureName"
          onFieldChange={updateFormData}
          disabled
        />
        <FormItem<PortSecurityFormData, "signatureDate">
          name="signatureDate"
          type="date-picker"
          label={t("security-clearance.signature-date")}
          testId="security-signatureDate"
          onFieldChange={updateFormData}
          timePicker={false}
          required
          disabled
        />
      </FormSection>
    </FormProvider>
  );
};

export default Signature;
